import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckboxRoundIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <circle cx="12" cy="12" r="12" fill="#EEEFEF" />
            <path
                d="M18 7.95001L9.75 16.2L6 12.45"
                stroke="#A7A9AC"
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
